import { useState } from "react";
import { Link } from "react-router-dom";

import "../ styles/home.css";

export const Home = () => {
  const [name, setName] = useState("");
  const [room, setRoom] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, room);
  };
  return (
    <div className="container">
      <div className="inputs">
        <form onSubmit={handleSubmit}>
          <p className="text">Username</p>
          <div>
            <input
              className="input"
              type="text"
              required
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </div>
          <p className="text">Room to join</p>
          <div>
            <input
              className="input"
              type="text"
              required
              value={room}
              onChange={(e) => {
                setRoom(e.target.value);
              }}
            />
          </div>
          <Link
            onClick={(e) => {
              if (!name || !room) {
                return e.preventDefault();
              }
            }}
            to={`/room?name=${name}&room=${room}`}>
            <button className="button">Join Room</button>
          </Link>
        </form>
      </div>
    </div>
  );
};
